import '../css/EquipePreview.css';
import dadosEquipe from '../../dados/equipe.json';

// "Conheça Nossa Equipe" da página inicial: mostra o diretor e as
// coordenadoras (grupo "coordenadores" de src/dados/equipe.json, o mesmo da
// página Nossa Equipe) e leva para a página completa.
// As fotos aparecem na ordem em que estão no equipe.json:
// 1.png Blayth, 2.png Danusa, 3.png Giselle, 4.png Lucimar.
const fotos = dadosEquipe.coordenadores;

const fotoUrl = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w600`;

const EquipePreview = () => (
  <section className="equipe-preview" aria-labelledby="titulo-equipe-preview">
    <h2 className="titulo-secao" id="titulo-equipe-preview">Conheça Nossa Equipe</h2>
    <p className="equipe-preview-sub">
      Direção e coordenação que acompanham de perto cada aluno, todos os dias.
    </p>

    <div className="equipe-preview-grade">
      {fotos.map((foto, i) => (
        <a key={foto.id} href="nossa-equipe" className="equipe-preview-foto">
          <img
            src={fotoUrl(foto.id)}
            alt={`Direção e coordenação do Colégio Líder - foto ${i + 1}`}
            loading="lazy"
          />
        </a>
      ))}
    </div>

    <a href="nossa-equipe" className="equipe-preview-botao">Ver a equipe completa</a>
  </section>
);

export default EquipePreview;
